
import React from "react";
import { useRole } from "@/hooks/useRole";
import { Loader2 } from "lucide-react";
import { GamesList } from "@/components/admin/games/list/GamesList";
import { AddEditGameDialog } from "@/components/admin/games/AddEditGameDialog";
import { GamesPageHeader } from "@/components/admin/games/GamesPageHeader";
import { GameSearchBar } from "@/components/admin/games/GameSearchBar";
import { GamesLoadingState } from "@/components/admin/games/GamesLoadingState";
import { AccessDenied } from "@/components/admin/games/AccessDenied";
import { useGamesAdmin } from "@/hooks/useGamesAdmin";

const JogosAdmin = () => {
  const { role, loading: roleLoading } = useRole();
  const {
    games,
    loading,
    repairing,
    isDialogOpen,
    setIsDialogOpen,
    isEditMode,
    currentGame,
    searchTerm,
    setSearchTerm,
    openAddDialog,
    openEditDialog,
    handleDelete,
    fetchGames,
    repairCovers
  } = useGamesAdmin();

  if (roleLoading) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-[#0f141c] pt-16">
        <Loader2 className="h-12 w-12 text-[#00B6F0] animate-spin" />
      </div>
    );
  }

  if (role !== "admin") {
    return <AccessDenied />;
  }

  return (
    <div className="bg-[#0f141c] min-h-screen pt-16 p-8">
      <div className="max-w-6xl mx-auto">
        <GamesPageHeader 
          openAddDialog={openAddDialog} 
          repairCovers={repairCovers}
          repairing={repairing}
        />

        <div className="mb-6">
          <GameSearchBar searchTerm={searchTerm} setSearchTerm={setSearchTerm} />
        </div>

        {loading ? (
          <GamesLoadingState />
        ) : (
          <GamesList 
            games={games} 
            onEdit={openEditDialog} 
            onDelete={handleDelete} 
            searchTerm={searchTerm}
            setSearchTerm={setSearchTerm}
          />
        )}
      </div>

      <AddEditGameDialog 
        isOpen={isDialogOpen} 
        setIsOpen={setIsDialogOpen} 
        isEditMode={isEditMode} 
        currentGame={currentGame} 
        onGameSaved={fetchGames} 
      />
    </div>
  );
};

export default JogosAdmin;
